/**
 * @generated SignedSource<<56b95af7ad5f86a7662d6ca066cee6a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FooterSubscribe_viewer$data = {
  readonly user?: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "FooterSubscribe_viewer";
};
export type FooterSubscribe_viewer$key = {
  readonly " $data"?: FooterSubscribe_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterSubscribe_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FooterSubscribe_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0b4835e8d59ed6347993a9029db90a8d";

export default node;
